import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../../primitives/Stack/index.js';
export const Container = /*#__PURE__*/_styled(props => {
  return _jsx(Stack, {
    ...props
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1inicll0"
} : {
  target: "e1inicll0",
  label: "Container"
})(({
  theme
}) => theme.typography.labelXSmall, ";color:", ({
  color,
  theme
}) => theme.colors[color], ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLRyIsImZpbGUiOiJDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgU3RhY2sgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1N0YWNrL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBDb250YWluZXIgPSBzdHlsZWQoKHByb3BzKSA9PiB7XG4gICAgcmV0dXJuIF9qc3goU3RhY2ssIHsgLi4ucHJvcHMgfSk7XG59KSBgXG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudHlwb2dyYXBoeS5sYWJlbFhTbWFsbH07XG4gIGNvbG9yOiAkeyh7IGNvbG9yLCB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnNbY29sb3JdfTtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db250YWluZXIuanMubWFwIl19 */"));